import { renderless, api } from "@opentiny/vue-renderless/image-viewer/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import { iconClose, iconChevronLeft, iconChevronRight, iconZoomOut, iconZoomIn, iconFullscreen, iconMinscreen, iconRepeat, iconRefres } from "@opentiny/vue-icon";
import "@opentiny/vue-theme/image-viewer/index.css";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  props: [].concat(props, ["urlList", "zIndex", "onSwitch", "onClose"]),
  components: {
    IconClose: iconClose(),
    IconChevronLeft: iconChevronLeft(),
    IconChevronRight: iconChevronRight(),
    IconZoomOut: iconZoomOut(),
    IconZoomIn: iconZoomIn(),
    IconFullscreen: iconFullscreen(),
    IconMinscreen: iconMinscreen(),
    IconRepeat: iconRepeat(),
    IconRefres: iconRefres()
  },
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", {
    attrs: {
      "name": "viewer-fade"
    }
  }, [_c("div", {
    staticClass: "tiny-image-viewer__wrapper",
    style: {
      "z-index": _vm.state.zIndex
    },
    on: {
      "mousewheel": function mousewheel($event) {
        $event.preventDefault();
      }
    }
  }, [_c("div", {
    staticClass: "tiny-image-viewer__mask"
  }), _c("span", {
    staticClass: "tiny-image-viewer__btn tiny-image-viewer__close",
    on: {
      "click": _vm.hide
    }
  }, [_c("icon-close", {
    staticClass: "tiny-svg-size"
  })], 1), !_vm.state.isSingle ? [_c("span", {
    staticClass: "tiny-image-viewer__btn tiny-image-viewer__prev",
    class: {
      "is-disabled": !_vm.state.infinite && _vm.state.isFirst
    },
    on: {
      "click": _vm.prev
    }
  }, [_c("icon-chevron-left", {
    staticClass: "tiny-svg-size"
  })], 1), _c("span", {
    staticClass: "tiny-image-viewer__btn tiny-image-viewer__next",
    class: {
      "is-disabled": !_vm.state.infinite && _vm.state.isLast
    },
    on: {
      "click": _vm.next
    }
  }, [_c("icon-chevron-right", {
    staticClass: "tiny-svg-size"
  })], 1)] : _vm._e(), _c("div", {
    staticClass: "tiny-image-viewer__btn tiny-image-viewer__actions"
  }, [_c("div", {
    staticClass: "tiny-image-viewer__actions-inner"
  }, [_c("icon-zoom-out", {
    staticClass: "tiny-svg-size",
    on: {
      "click": function click($event) {
        return _vm.handleActions("zoomOut");
      }
    }
  }), _c("icon-zoom-in", {
    staticClass: "tiny-svg-size",
    on: {
      "click": function click($event) {
        return _vm.handleActions("zoomIn");
      }
    }
  }), _c("i", {
    staticClass: "tiny-image-viewer__actions-divider"
  }), _c(_vm.state.mode.icon, {
    tag: "component",
    staticClass: "tiny-svg-size",
    on: {
      "click": _vm.toggleMode
    }
  }), _c("i", {
    staticClass: "tiny-image-viewer__actions-divider"
  }), _c("icon-repeat", {
    staticClass: "tiny-svg-size",
    on: {
      "click": function click($event) {
        return _vm.handleActions("anticlocelise");
      }
    }
  }), _c("icon-refres", {
    staticClass: "tiny-svg-size",
    on: {
      "click": function click($event) {
        return _vm.handleActions("clocelise");
      }
    }
  })], 1)]), _c("div", {
    staticClass: "tiny-image-viewer__canvas"
  }, [_vm._l(_vm.urlList, function(url, i) {
    return [i === _vm.state.index ? _c("img", {
      key: url,
      ref: "img_" + i,
      refInFor: true,
      staticClass: "tiny-image-viewer__img",
      style: _vm.state.imgStyle,
      attrs: {
        "src": _vm.state.currentImg
      },
      on: {
        "error": _vm.handleImgError,
        "mousedown": _vm.handleMouseDown,
        "load": _vm.handleImgLoad
      }
    }) : _vm._e()];
  })], 2)], 2)]);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var pc = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  pc as default
};
